import { ProductViewConfig } from './product-view-config.model';

import { Category } from '@core/domain/models/category.models';
import { MenuCategory } from '@shared/header/models/category.model';

export interface ProductViewTemplateModel extends ProductViewConfig {
    showSoldOut: boolean;
    hasVideo: boolean;
    bannerProductFinded: boolean;
}

export interface CategoryConfiguration {
    productConf: Map<number, {
        hiddenField: HiddenFieldType;
        style: GridProductStyle;
        defaultImageType: string;
    }>;
    soldOut: boolean;
    category: Category | MenuCategory;
    isCategoryNew?: boolean;
}

export interface GridProductStyle {
    tintColor: string;
    backgroundColor: string;
}

export enum HiddenFieldType {
    ALL = 'all',
    DESCRIPTION = 'description',
    PRICE = 'price',
}

export enum ProductViewPlaceValue {
    ADD_CART = 'ADD_CART',
    BUNDLE_DETAIL = 'BUNDLE_DETAIL',
    CART = 'CART',
    CS_BS = 'CS_BS',
    ERROR = 'ERROR',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
    PRODUCT_CUSTOM_CATEGORY = 'PRODUCT_CUSTOM_CATEGORY',
    PRODUCT_DETAIL = 'PRODUCT_DETAIL',
    PRODUCT_GRID = 'PRODUCT_GRID',
    PRODUCT_LAST_SIZES = 'PRODUCT_LAST_SIZES',
    PRODUCT_NEW_COLLECTION = 'PRODUCT_NEW_COLLECTION',
    SEARCH = 'SEARCH',
    VIEWER_3D = 'VIEWER_3D',
    WISHLIST = 'WISHLIST',
    SMART_ASSISTANT = 'SMART_ASSISTANT',
}

// TO REFACTOR: move to the domain layer. There are some dependant pieces in higher layers
export type ProductViewPlace = keyof typeof ProductViewPlaceValue;
